module.exports = __webpack_public_path__ + "static/media/Logo.4ab50c51.svg";